import io from 'socket.io-client';
import { BASE_HOST } from './api.js';

class WebSocketService {
  constructor() {
    this.socket = null;
    this.alertCallback = null;
  }

  connect(serverUrl = BASE_HOST) {
    // Si ya existe un socket conectado o intentando conectar, no duplicamos
    if (this.socket && this.socket.connected) return;

    // Crear la instancia con opciones de reconexión estables
    this.socket = io(serverUrl, {
      path: '/socket.io/',
      transports: ['polling', 'websocket'], // Iniciar con polling y escalar a websocket
      allowEIO3: true,
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 2000
    });

    this.socket.on('connect', () => {
      console.log('Conectado al servidor WebSocket:', this.socket.id);
    });

    this.socket.on('disconnect', (reason) => {
      console.log('Desconectado del servidor WebSocket:', reason);
    });

    this.socket.on('alert', (data) => {
      if (this.alertCallback) {
        this.alertCallback(data);
      }
    });

    this.socket.on('connect_error', (error) => {
      console.error('Error de conexión WebSocket:', error);
    });
  }

  setAlertCallback(callback) {
    this.alertCallback = callback;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

const instance = new WebSocketService();
export default instance;